import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=0e63de06&"
import script from "./Aside.vue?vue&type=script&lang=js&"
export * from "./Aside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e63de06')) {
      api.createRecord('0e63de06', component.options)
    } else {
      api.reload('0e63de06', component.options)
    }
    module.hot.accept("./Aside.vue?vue&type=template&id=0e63de06&", function () {
      api.rerender('0e63de06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/aside/Aside.vue"
export default component.exports